<template>
  <div id="terms">
    <!-- #######  THIS IS A COMMENT - Visible only in the source editor #########-->
    <!-- #######  THIS IS A COMMENT - Visible only in the source editor #########-->
    <img class="girona-logo" title="Girona FC" src="@/assets/img/logo_header.png" width="300" style="display: block; margin: 0 auto">
    <p style="text-align: center">&nbsp;</p>
    <p style="text-align: center">
    <strong>BASES LEGALS DE L&rsquo;ACTIVACIÓ:</strong>
    </p>
    <p style="text-align: center">
    <strong>&ldquo;NOU ESCUT OFICIAL DEL GIRONA FC&rdquo;</strong>
    </p>

    <p class="p2"><span class="Apple-converted-space">&nbsp;</span></p>
    <p class="p3">
      GIRONA F<span class="s1">&Uacute;</span>TBOL CLUB SAD (Girona FC) amb
      domicili social en Avinguda Montilivi, 141, 17003 - Girona, y CIF
      A-17088329, ha posat en marxa la seg<span class="s1">&uuml;</span>ent
      activaci<span class="s1">&oacute;</span> &ldquo;Votaci&oacute; nou
      escut&rdquo;, d&rsquo;acord a les seg<span class="s1">&uuml;</span>ents
      condicions:
    </p>
    <p class="p3">
      <strong>1. VIG&Egrave;NCIA</strong><span class="s2"><br /> </span>La
      votaci<span class="s1">&oacute;</span> estar<span class="s1"
        >&agrave;</span
      >
      activa des del 18 d&rsquo;agost de 2021 fins al 19 de setembre de
      2021<strong>.</strong>
    </p>
    <p class="p3">
      <strong>2. CAPACITAT PER A PARTICIPAR.</strong
      ><span class="s2"><br /> </span>Aquesta consulta est<span class="s1"
        >&agrave;</span
      >
      limitada a Socis del Girona FC. <span class="s1">&Uacute;</span>nicament
      podran participar aquells Socis del Girona FC sense cap quota pendent i
      sense sancions actives.
    </p>
    <p class="p3">
      <strong>3. MEC</strong><span class="s1"><strong>&Agrave;</strong></span
      ><strong>NICA</strong><span class="s2"><br /> </span>El soci tindr<span
        class="s1"
        >&agrave;</span
      >
      acc<span class="s1">&eacute;</span>s a una votaci&oacute; d&rsquo;una
      &uacute;nica fase en la que haur&agrave; d&rsquo;escollir entre una de les
      dues versions del nou escut.
    </p>
    <p class="p3">
      El Soci podr<span class="s1">&agrave;</span> participar en la
      votaci&oacute; accedint al seg&uuml;ent enlla&ccedil;:
      <a href="https://escut.gironafc.cat/"
        ><span class="s3">https://escut.gironafc.cat</span
        ><span class="s2"
          ><br />
          <br /> </span></a
      >El Club tindr<span class="s1">&agrave;</span> en compte les votacions
      dels Socis per a decidir el disseny definitiu del nou escut del Girona
      FC.<span class="s2"><br /> </span>
    </p>
    <p class="p3">
      <strong>4. PROTECCI</strong
      ><span class="s1"><strong>&Oacute;</strong></span
      ><strong> DE DADES</strong>
    </p>
    <table class="t1" cellspacing="0" cellpadding="0">
      <tbody>
        <tr>
          <td class="td1" valign="middle">
            <p class="p3">
              El Girona FC informa que, mitjan<span class="s1">&ccedil;</span
              >ant la participaci<span class="s1">&oacute;</span> en aquesta
              activaci<span class="s1">&oacute;</span>, el participant
            </p>
          </td>
        </tr>
        <tr>
          <td class="td2" valign="middle">
            <p class="p4">
              atorga el consentiment expr<span class="s1">&eacute;</span>s en la
              cessi<span class="s1">&oacute;</span> de les seves dades personals
              <span class="s1">&uacute;</span>nicament per al prop<span
                class="s1"
                >&ograve;</span
              >sit de la votaci<span class="s1">&oacute;</span> i q<span
                class="s1"
                >&uuml;</span
              >estionari sobre el nou escut del Club, aix<span class="s1"
                >&iacute;</span
              >
              com per al seu posterior tractament a favor del Girona FC, sense
              perjudici dels drets que assisteixin al participant tal com: dret
              d'acc<span class="s1">&eacute;</span>s, rectificaci<span
                class="s1"
                >&oacute;</span
              >, supressi<span class="s1">&oacute;</span>, limitaci<span
                class="s1"
                >&oacute;</span
              >, portabilitat, oposici<span class="s1">&oacute;</span> ja no ser
              objecte de decisions individualitzades. Qualsevol revocaci<span
                class="s1"
                >&oacute;</span
              >
              a aquest consentiment s'haur<span class="s1">&agrave;</span>
              d'enviar un correu a:
              <a href="mailto:protecciondatos@gironafc.cat"
                ><span class="s3">protecciondatos@gironafc.cat</span></a
              >
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <p class="p5">&nbsp;</p>
    <p class="p3"><strong>5. CONSIDERACIONS GENERALS</strong></p>
    <table class="t1" cellspacing="0" cellpadding="0">
      <tbody>
        <tr>
          <td class="td3" valign="middle">
            <p class="p3">
              La simple participaci<span class="s1">&oacute;</span> en la
              present acci<span class="s1">&oacute;</span> implica
              l'acceptaci<span class="s1">&oacute;</span>
              <span class="s1">&iacute;</span>ntegra de les presents bases
              legals, per la qual cosa la manifestaci<span class="s1"
                >&oacute;</span
              >
              en el sentit de la no acceptaci<span class="s1">&oacute;</span> de
              la totalitat o part de les mateixes implicar<span class="s1"
                >&agrave;</span
              >
              l'exclusi<span class="s1">&oacute;</span> del participant.<span
                class="s2"
                ><br />
              </span>
            </p>
            <p class="p4">
              El Girona FC es reserva el dret de qualsevol canvi sobre les
              presents bases legals, aix<span class="s1">&iacute;</span> com
              cancel&middot;lar, suspendre o ampliar aquesta acci<span
                class="s1"
                >&oacute;</span
              >, que ser<span class="s1">&agrave;</span> degudament notificat a
              tots els participants, a trav<span class="s1">&eacute;</span>s del
              microsite
              <a href="https://escut.gironafc.cat/"
                ><span class="s3">https://escut.gironafc.cat</span></a
              >
            </p>
          </td>
        </tr>
        <tr>
          <td class="td4" valign="middle">
            <p class="p6">&nbsp;</p>
            <p class="p4">
              <span class="s2"><br /> </span>Les presents bases legals es
              regeixen per la llei espanyola.
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  components: {},
  mounted() {},
  methods: {},
};
</script>


<style>
#terms {
  padding: 4em;
}
</style>